<nz-input-group [nzSuffix]="suffixIconSearch" class="{{case.key==='in-banner' && 'outline outline-[#aaa] outline-offset-[3px] outline-0 hover:outline-1 focus:outline-1 border-0 text-2xl ant-input-group-xl relative' || ''}}">
  <input type="text" nz-input placeholder="Search by name or industry" class="inline-block mr-auto {{case.key==='in-banner' ? 'ant-input-xl' : case.key==='search-result' ? 'ant-input-lg' : ''}}{{ inputClass || ''}} peer"
  (focus)="handleUpdateShowSearch('focus')" (keyup.enter)="onSearch($event)"
    />
</nz-input-group>
<ng-template #suffixIconSearch>
  <!-- case: in-banner -->
  <button
    *ngIf="case.key==='in-banner'"
    (click)="handleUpdateShowSearch('click')"
    class="cursor-pointer text-gray-700 hover:text-primary-500 rounded-full hover:bg-gray-300 bg-transparent flex items-center justify-center w-12 h-12"
  >
    <svg-icon
      [key]="(case.props?.showSearch) ? 'xMenuHeaderIcon' : 'searchIcon'"
      fontSize="18px"
    ></svg-icon>
  </button>

  <!-- case: header | search-result -->
  <svg-icon
    *ngIf="case.key==='in-header' || case.key==='search-result'"
    [key]="(case.props?.showSearch) ? 'xMenuHeaderIcon' : 'searchIcon'"
    fontSize="18px"
    (click)="handleUpdateShowSearch('click')"
    class="cursor-pointer text-gray-700 hover:text-primary-500"
  ></svg-icon>
</ng-template>
